import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { useComponentTheme } from '@chegg-ui/theme';
import { ShimmerAvatar } from '..';
import { getThemeConfig, ShimmerContentCardContainer, ShimmerContentCardContent, ShimmerContentCardFooter } from '../styles';
import ShimmerBodyText from './ShimmerBodyText';
import ShimmerTitleText from './ShimmerTitleText';

var ShimmerContentCard = function ShimmerContentCard(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? "".concat(300 / 16, "rem") : _ref$width,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? false : _ref$media,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["width", "media", "theme"]);

  var componentTheme = useComponentTheme({
    name: 'Shimmer',
    theme: getThemeConfig(theme)
  });
  return /*#__PURE__*/React.createElement(ShimmerContentCardContainer, _extends({
    customTheme: componentTheme,
    $width: width
  }, props), /*#__PURE__*/React.createElement(ShimmerContentCardContent, {
    $media: media,
    "data-test": "".concat(props['data-test'], "-content"),
    customTheme: componentTheme
  }, /*#__PURE__*/React.createElement(ShimmerTitleText, null), /*#__PURE__*/React.createElement(ShimmerBodyText, {
    line: 2
  })), /*#__PURE__*/React.createElement(ShimmerContentCardFooter, {
    customTheme: componentTheme
  }, /*#__PURE__*/React.createElement(ShimmerAvatar, {
    size: "xs"
  })));
};

ShimmerContentCard.displayName = 'ShimmerContentCard';
export default ShimmerContentCard;